import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import EntryPicker from 'focus_groups/components/entry_picker';
import {
  toggleEditEntries, toggleSelectedEntries, updateGroupEntries,
} from 'focus_groups/ducks/view_state';

export function mapStateToProps({ project: { focusGroups } }) {
  return {
    ...focusGroups.viewState,
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    toggle: toggleEditEntries,
    toggleEntry: toggleSelectedEntries,
    setEntries: updateGroupEntries,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EntryPicker);



// WEBPACK FOOTER //
// ./focus_groups/containers/edit_entries.js